import type { BookingWizardCustomer } from "api-client";
import type { CreateBookingOption } from "design-components";

export type BookingWizardCustomerOptionMode = "create" | "edit" | "filter";

export interface BookingWizardCustomerOptionsParams {
  mode?: BookingWizardCustomerOptionMode;
  /** Edit mode — hydrated customer id; inactive option stays selectable. */
  selectedCustomerId?: string | null;
}

const INACTIVE_CUSTOMER_STATUS_CHIP = "Inactive";

function isBookingWizardCustomerInactive(customer: BookingWizardCustomer): boolean {
  return customer.customerStatus === "inactive";
}

export function bookingWizardCustomerOptions(
  customers: BookingWizardCustomer[],
  params: BookingWizardCustomerOptionsParams = {},
): CreateBookingOption[] {
  const mode = params.mode ?? "create";
  const selectedCustomerId = params.selectedCustomerId?.trim() ?? "";

  return customers.map((customer) => {
    const value = String(customer.customerId);
    const inactive = isBookingWizardCustomerInactive(customer);
    const isHydratedSelection = mode === "edit" && value === selectedCustomerId;
    const showInactiveChip = inactive && mode !== "filter";
    const disabled = inactive && mode !== "filter" && !isHydratedSelection;

    return {
      value,
      label: customer.customerName,
      ...(disabled ? { disabled: true } : {}),
      ...(showInactiveChip ? { statusChipLabel: INACTIVE_CUSTOMER_STATUS_CHIP } : {}),
    };
  });
}
